<form [formGroup]="userForm">
	<div class="settings-general" *ngIf="userInfo else loading">
		<div class="button-container">
			<button type="button" mat-button color="accent"
				class="user-button" (click)="onEdit()"
				*ngIf="!editForm" [disabled]="!enableEdit"><span class="text-color" translate>quapp.action.edit</span>
				<mat-icon iconPositionEnd svgIcon="md:edit" class="icon-color"></mat-icon>
			</button>
			<div *ngIf="editForm">
				<button type="button" mat-button color="accent" class="user-button cancel-button"
					(click)="onCancel()"><span class="text-color" translate>sb.Cancel</span>
				</button>
				<button type="button" mat-button color="accent" class="user-button"
					(click)="onSave()" [disabled]="userForm.invalid"><span class="text-color" translate>settings.save-changes</span>
					<mat-icon iconPositionEnd class="icon-color" svgIcon="save_disk"></mat-icon>
				</button>
			</div>
		</div>
		<div class="user-card-block grid-column-one-full">
			<div class="user-card-title">
				<span class="user-card-title-label" translate>settings.identity</span>
				<span class="user-card-title-comment" translate>settings.identity.desc</span>
			</div>
			<div class="user-card-infos-block" *ngIf="!editForm">
				<div class="user-card-info">
					<span class="user-card-info-label" translate>settings.firstname</span>
					<span class="user-card-info-value user-card-info-text-corpo-color">
						{{userInfo.firstName}}
					</span>
				</div>
				<div class="user-card-info">
					<span class="user-card-info-label" translate>settings.lastname</span>
					<span class="user-card-info-value user-card-info-text-corpo-color">
						{{userInfo.lastName}}
					</span>
				</div>
				<div class="user-card-info">
					<span class="user-card-info-label" translate>settings.email</span>
					<span class="user-card-info-value">{{ userInfo.address.email }}</span>
				</div>
				<div class="user-card-info" *ngIf="userInfo.address.requestedMail">
					<span class="user-card-info-label requested-mail-label" translate>settings.requested.email</span>
					<span class="user-card-info-value user-card-info-text-corpo-color">
						{{userInfo.address.requestedMail}}
					</span>
				</div>
				<div class="user-card-info">
					<span class="user-card-info-label" translate>settings.phone-number</span>
					<span class="user-card-info-value">{{ userInfo.address.phoneNumber?
						userInfo.address.phoneNumber : UNDERSCORE }}</span>
				</div>
			</div>

			<div class="user-card-infos-block" *ngIf="editForm">
				<mat-form-field>
					<mat-label translate>settings.firstname</mat-label>
					<input class="div-mat-input-text" formControlName="firstName" matInput type="text"
						spellcheck="false" autocomplete="off">
					<mat-icon matSuffix class="div-mat-input-icon" svgIcon="md:edit"></mat-icon>
					<mat-error *ngIf="userForm.controls['firstName'].dirty && userForm.controls['firstName'].invalid">
						<span class="span-field">Please enter valid First
							Name</span>
					</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label translate>settings.lastname</mat-label>
					<input formControlName="lastName" matInput type="text" spellcheck="false" autocomplete="off">
					<mat-icon matSuffix class="div-mat-input-icon" svgIcon="md:edit"></mat-icon>
					<mat-error *ngIf="userForm.controls['lastName'].dirty && userForm.controls['lastName'].invalid">
						<span class="span-field">Please enter valid Last
							Name</span>
					</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label translate>settings.email</mat-label>
					<input class="div-mat-input-text" formControlName="email" matInput spellcheck="false"
						autocomplete="off">
					<mat-icon matSuffix class="div-mat-input-icon" svgIcon="md:edit"></mat-icon>
					<mat-error *ngIf="userForm.controls['email'].dirty && userForm.controls['email'].invalid">
						<span class="span-field">Please enter valid email</span>
					</mat-error>
					<mat-error *ngIf="userForm.hasError('required','email')">
						<span class="span-field">Email is required</span>
					</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label translate>settings.phone-number</mat-label>
					<input class="div-mat-input-text" formControlName="phoneNumber" matInput type="text"
						spellcheck="false" autocomplete="off">
					<mat-icon matSuffix class="div-mat-input-icon" svgIcon="md:edit"></mat-icon>
					<mat-error
						*ngIf="userForm.controls['phoneNumber'].invalid && userForm.controls['phoneNumber'].dirty">
						<span class="span-field">Please enter valid Phone Number</span>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="grid-column-one-half card-block" *ngIf="isSelfCard()">
			<div class="card-title">
				<span class="card-title-label" translate>settings.visibility</span>
				<span class="card-title-comment" translate>settings.general.helper</span>
			</div>
			<div class="card-block-body flex-column flex-space-between height-100">
				<mat-form-field class="card-block-from-field">
					<mat-label translate>settings.visibility.data</mat-label>
					<mat-select [formControl]="visibilityGroupControl"
						(selectionChange)="handleVisibilityUpdate($event.value)">
						<mat-optgroup *ngFor="let group of visibilityGroupOptions" [label]="group.name"
							[disabled]="group.disabled">
							<mat-option *ngFor="let visi of group.vgd" [value]="visi.value">
								{{ visi.viewValue }}
							</mat-option>
						</mat-optgroup>
					</mat-select>
				</mat-form-field>
				<div class="card-block-from-field flex-2">
					<span translate>settings.visibility.info</span>
					<br />
					<span translate>settings.visibility.changeimpact</span>
				</div>
				<div class="flex-column flex-align-right" *ngIf="user?.isDelegating()">
					<button type="button" mat-button color="accent" class="settings-item"
						(click)="changeDelegatedOrganization()">
						<span translate>settings.delegation.changement</span>
					</button>
				</div>
			</div>
		</div>
		<div class="card-block grid-column-one-half" *ngIf="isSelfCard()">
			<div class="card-title">
				<span class="card-title-label" translate>settings.general</span>
				<span class="card-title-comment" translate>settings.general.helper</span>
			</div>
			<div class="card-block-body">
				<mat-form-field class="card-block-from-field">
					<mat-label translate>user.language</mat-label>
					<mat-select [formControl]="languageControl" (selectionChange)="handleLanguageUpdated($event.value)">
						<mat-option *ngFor="let lang of langOptions" [value]="lang.value">
							{{ lang.viewValue }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field class="card-block-from-field">
					<mat-label translate>settings.select.download-type</mat-label>
					<mat-select [formControl]="downloadControl" (selectionChange)="handleDownloadUpdated($event.value)">
						<mat-option *ngFor="let type of downloadOptions" [value]="type.value">
							{{ type.viewValue | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="grid-column-one-full card-block">
			<div class="card-title">
				<span class="card-title-label" translate>settings.organizations</span>
				<span class="card-title-comment" translate>settings.organizations.desc</span>
			</div>
			<div *ngIf="gridOptions">
				<div class="copo-card-grid-container">
					<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions" [modules]="modules"
						(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)">
					</ag-grid-angular>
				</div>
			</div>
		</div>
		<div class="user-card-block grid-column-one-full">
			<div class="user-card-title">
				<span class="user-card-title-label" translate>settings.activity</span>
				<span class="user-card-title-comment" translate>settings.activity-desc</span>
			</div>
			<div class="user-card-infos-block">
				<div class="user-card-info">
					<span class="user-card-info-label" translate>settings.last-connection-date</span>
					<span class="user-card-info-value">
						{{userInfo.lastConnectionDate | date: 'dd/MM/yyyy'}}
					</span>
				</div>

				<div class="user-card-info">
					<span class="user-card-info-label" translate>datacenter-filter.creation-date</span>
					<span class="user-card-info-value">
						{{userInfo.creationDate | date: 'dd/MM/yyyy'}}
					</span>
				</div>
			</div>
		</div>
	</div>
</form>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
